import { render, staticRenderFns } from "./RegionalAlarmInfos.vue?vue&type=template&id=d098cb9e&scoped=true&"
import script from "./RegionalAlarmInfos.vue?vue&type=script&lang=js&"
export * from "./RegionalAlarmInfos.vue?vue&type=script&lang=js&"
import style0 from "./RegionalAlarmInfos.vue?vue&type=style&index=0&id=d098cb9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d098cb9e",
  null
  
)

export default component.exports